import { render, staticRenderFns } from "./points-ring.vue?vue&type=template&id=20b82fee"
import script from "./points-ring.vue?vue&type=script&lang=js"
export * from "./points-ring.vue?vue&type=script&lang=js"
import style0 from "./points-ring.vue?vue&type=style&index=0&id=20b82fee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports